import './card.css';

import React from 'react';
import { Link } from 'react-router-dom';

const Card = ({ name, summary, username, image, logos }) => {
  return (
    <div className="contribute_card">
      <Link to="." style={{ textDecoration: 'none' }}>
        <div className="">
          <img
            src={image}
            className=""
            alt=""
            style={{
              maxHeight: '500px',
              maxWidth: '500px',
            }}
          />
        </div>
        <div className="w-100 pt-4">
          <h2 className="text-white fw-regular">{name}</h2>
        </div>
        <p className="text-white m-0">{summary}</p>
        <p className="text-white fw-light">{username}</p>
        <div className="logos">
          {logos.map((v) => {
            return (
              <div key={v.image}>
                <img
                  src={v.image}
                  className=""
                  alt=""
                  style={{ width: '100px', display: 'inline' }}
                />
              </div>
            );
          })}
        </div>

        <div className="coin_container" />
      </Link>
    </div>
  );
};

export default Card;
